const List = 'list'
const Service = 'service'

export default {
    List: List,
    Service: Service,
}
